import React from 'react'
import {Dimensions,ScrollView,Linking,TouchableOpacity,Image, View, Text, StyleSheet, Button } from 'react-native'
import {connect} from 'react-redux'
import Firebase from '../config/Firebase'
import * as RootNavigation from '../controllers/RootNavigation';
import strings from "../config/strings"
import colors from "../config/colors"
import PopUpButton from "../components/PopUpButton"
import imagepaths from '../config/imagepaths';
import ServiceTermsScreen from '../screens/ServiceTermsScreen'
import metrics, { logowidth } from "../config/metrics"
import { updateEmail, updatePassword, logout} from '../actions/User'
import { bindActionCreators } from 'redux'
import * as MailComposer from 'expo-mail-composer';
import * as Analytics from 'expo-firebase-analytics';

class CancelSubscriptionScreen extends React.Component {

  handleSubscriptionCancel = async () => {
    // console.log("handleSubscriptionCancel for user " + this.props.user.email);
     // Linking.openURL("mailto:support@popupyogaoulu.com");
     MailComposer.composeAsync({
       subject: 'Videopalvelun tilauksen peruutus',
       body: 'Peruisin videopalvelun tilauksen \nkäyttäjälle: '+ this.props.user.email + ' \nalkaen ' + Date(),
       recipients: ['support@popupyogaoulu.com'],
       isHtml: true
     }).then( (response) => {
       Analytics.logEvent('open_cancel_subscription_email_v1', {})
       alert("Mikäli lähetit sähköpostin niin peruutuksesi käsitellään mahdollisimman pian eikä sinulta veloiteta seuraavaa katselukautta.")
       RootNavigation.pop();
     })
     .catch( error => {
       // console.log("Error: " + error);
       alert("Tilauksen peruminen epäonnistui, voit perua tilauksen sähköpostilla support@popupyogaoulu.com")
     });
  }


  handle_billing_type_change_request = async () => {
    // console.log("handle_billing_type_change_request for user " + this.props.user.email);
     // Linking.openURL("mailto:support@popupyogaoulu.com");
     MailComposer.composeAsync({
       subject: 'Vaihto luottokorttiveloitukseen',
       body: 'Haluaisin vaihtaa tilauksen luottokorttiveloitukseen seuraavalle katselukaudelle. \käyttäjätunnukseni on '+ this.props.user.email,
       recipients: ['support@popupyogaoulu.com'],
       isHtml: true
     }).then( (response) => {
       Analytics.logEvent('open_change_to_card_billing_v1', {})
       alert("Mikäli lähetit sähköpostin niin pyyntösi käsitellään mahdollisimman pian.")
       RootNavigation.pop();
     })
     .catch( error => {
       // console.log("Error: " + error);
       alert("Sähköpostin lähetys epäonnistui, voit perua tilauksen sähköpostilla support@popupyogaoulu.com")
     });
  }

  componentDidMount = async () => {
    Dimensions.addEventListener('change', (e) => {
      const { width, height } = e.window;
      this.widthScale = this.calculateImageScaleFactor(width,height)
      this.width = width;
      this.height = height;
      this.forceUpdate();
    })
  }

  constructor() {
    super()
    this.width = Dimensions.get('window').width
    this.height = Dimensions.get('window').height
    this.widthScale = this.calculateImageScaleFactor(Dimensions.get('window').width)
  }

  calculateImageScaleFactor = (width,height) => {
    // console.log("widthScale =" + width/800*0.70);
    // console.log("heightScale = " + height/200);
    return width/240*0.70;
  }

  showServiceTerms = () => {
    // console.log("showServiceTerms");
    RootNavigation.navigate('ShowServiceTerms');
  }

  render() {
    return (
      <ScrollView>
        <View style={styles.container}>
          <View style={styles.form}>
            {!Firebase.auth().currentUser || !Firebase.auth().currentUser.photoURL && (<Image style={[styles.logo,{width: 120, height:120}]} source={imagepaths.logo} />)}
            {Firebase.auth().currentUser.photoURL && (<Image style={styles.profileImage} source={{uri: Firebase.auth().currentUser.photoURL}} />)}
            <Text style={styles.formText}>{Firebase.auth().currentUser.displayName}</Text>
            <Text style={styles.formText}>{this.props.user.email}</Text>
            <Text style={styles.formText}></Text>
            <Text style={styles.cancelDescText}>Emme voineet ladata tilauksen hallintasivua.</Text>
          </View>
          <View style={styles.sectionHeader}>
            <TouchableOpacity style={{width: metrics.DEVICE_WIDTH/2, padding:15, alignSelf:'center'}} onPress={() => this.handleSubscriptionCancel()}>
               <Text style={{fontSize: 18, color: colors.DODGER_BLUE, textAlign: 'center'}}>  Peru tilaus sähköpostilla </Text>
            </TouchableOpacity>
          </View>
          <Text style={styles.formText}></Text>
          <View style={styles.sectionHeader}>
            <TouchableOpacity style={{width: metrics.DEVICE_WIDTH/2, padding:15, alignSelf:'center'}} onPress={() => this.handle_billing_type_change_request()}>
               <Text style={{fontSize: 18, color: colors.DODGER_BLUE, textAlign: 'center'}}>  Vaihda luottokorttiveloitukseen</Text>
            </TouchableOpacity>
          </View>
          <Text style={styles.formText}></Text>
          <View style={styles.sectionHeader}>
            <TouchableOpacity style={{width: metrics.DEVICE_WIDTH/2, padding:15, alignSelf:'center'}}  onPress={() => this.showServiceTerms()}>
              <Text style={{fontSize: 18, color: colors.DODGER_BLUE, textAlign: 'center'}}>  {strings.SERVICE_TERMS_LINK} </Text>
           </TouchableOpacity>
         </View>
         <Text style={styles.formText}></Text>
         <Text style={styles.formText}></Text>
       </View>
     </ScrollView>
    )
  }
}

const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.WHITE,
      alignItems: 'center',
      justifyContent: "space-between",
    },
    logo: {
      marginTop: "10%",
      marginBottom: 10,
      alignSelf: "center",
      // width: logowidth(),
      // height: logowidth(),
    },
    profileImage: {
      marginTop: "10%",
      marginBottom: 10,
      alignSelf: "center",
      width: logowidth(),
      height: logowidth(),
      borderRadius: 150 / 2,
      overflow: "hidden",
      borderWidth: 1,
      borderColor: colors.POPUP_LOGO_PURPLE
    },
    form: {
      flex: 1,
      backgroundColor: colors.WHITE,
      justifyContent:'flex-start',
      width: "80%",
    },
    formText: {
      fontSize: 18,
      color: colors.BLACK,
      padding:10,
      alignSelf:'center'
    },
    cancelDescText: {
      fontSize: 14,
      color: colors.BLACK,
      // paddingTop: "1%",
      paddingBottom: "1%",
      alignSelf:'center',
      textAlign: 'center'
    },
     sectionHeader: {
       width: "80%",
       alignItems: 'flex-start',
       borderWidth: StyleSheet.hairlineWidth,
       borderColor: colors.POPUP_CYAN_D,
       backgroundColor: colors.WHITE,
     },
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ updateEmail, updatePassword, logout }, dispatch)
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
      mapStateToProps,
      mapDispatchToProps
)(CancelSubscriptionScreen)
